// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"55204ccb","34":"8c49283c","162":"cbab0804","254":"e9971c2f","483":"d824bc19","504":"58268461","512":"289eb07a","664":"4c415a6f","754":"4c3df804","808":"958501f4","995":"13649fdf"}[chunkId] + ".chunk.js";
};